/* tslint:disable */
/* eslint-disable */
/**
 * crm-campaigns
 * crm-campaigns
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskTemplateReminders
 */
export interface TaskTemplateReminders {
    /**
     * 
     * @type {string}
     * @memberof TaskTemplateReminders
     */
    reminder_type: TaskTemplateRemindersReminderTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof TaskTemplateReminders
     */
    reminder_time_minutes_value: number;
}


/**
 * @export
 */
export const TaskTemplateRemindersReminderTypeEnum = {
    Email: 'Email',
    InApp: 'In-App'
} as const;
export type TaskTemplateRemindersReminderTypeEnum = typeof TaskTemplateRemindersReminderTypeEnum[keyof typeof TaskTemplateRemindersReminderTypeEnum];


/**
 * Check if a given object implements the TaskTemplateReminders interface.
 */
export function instanceOfTaskTemplateReminders(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "reminder_type" in value;
    isInstance = isInstance && "reminder_time_minutes_value" in value;

    return isInstance;
}

export function TaskTemplateRemindersFromJSON(json: any): TaskTemplateReminders {
    return TaskTemplateRemindersFromJSONTyped(json, false);
}

export function TaskTemplateRemindersFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskTemplateReminders {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reminder_type': json['reminder_type'],
        'reminder_time_minutes_value': json['reminder_time_minutes_value'],
    };
}

export function TaskTemplateRemindersToJSON(value?: TaskTemplateReminders | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reminder_type': value.reminder_type,
        'reminder_time_minutes_value': value.reminder_time_minutes_value,
    };
}

